export const vfxData = [
    {
        title: 'SIMILIS',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: 'https://films.buzzstudios.org/fireandsound',
        details: {
            origin: 'AECT 2030 - Leaders in Progress & Service for the Creative Industries',
            date: 'Spring 2026',
            tools: 'ComfyUI, DaVinci Resolve',
            role: 'Director, Writer, Editor, VFX, Production Design'
        },
        social_url: 'https://youtu.be/BlbMidX6iYM'
    },
    
    {
        title: 'Parasocialite',
        img: '/assets/images/extras/vfx/parasocialite.png',
        //link: 'https://films.buzzstudios.org/fireandsound',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2026',
            tools: 'Blender, DaVinci Resolve',
            role: 'VFX'
        },
        //social_url: 'https://youtu.be/RlQvampEqFw?si=CUWbOjkP5GufNOeH'
    },

    /*
    {
        title: 'Weight',
        img: '/assets/images/extras/vfx/parasocialite.png',
        //link: 'https://films.buzzstudios.org/fireandsound',
        details: {
            origin: 'LMC 3406 - Video Production',
            date: 'Spring 2026',
            //tools: 'Blender, DaVinci Resolve',
            role: 'VFX Consulting'
        },
        //social_url: 'https://youtu.be/RlQvampEqFw?si=CUWbOjkP5GufNOeH'
    },
    */
    
    {
        title: 'Fire and Sound',
        img: '/assets/images/extras/vfx/ufo.PNG',
        link: 'https://films.buzzstudios.org/fireandsound',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2026',
            tools: 'Blender, DaVinci Resolve',
            role: 'VFX'
        },
        //social_url: 'https://youtu.be/RlQvampEqFw?si=CUWbOjkP5GufNOeH'
    },
    
    {
        title: 'Schnitzelliebhaber',
        img: '/assets/images/extras/vfx/schnitzel.png',
        link: 'https://films.buzzstudios.org/schnitzel',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Fall 2025',
            //tools: 'Blender, DaVinci Resolve',
            role: 'Writer, Production Design'
        },
        //social_url: 'https://youtu.be/RlQvampEqFw?si=CUWbOjkP5GufNOeH'
    },
    
    {
        title: 'Traffic Flow',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'Bumblebee Tuna Cans Film Festival',
            date: 'Fall 2025',
            tools: 'Blender, DaVinci Resolve',
            role: 'Director, Writer, Editor, Animator'
        },
        social_url: 'https://youtu.be/RlQvampEqFw?si=CUWbOjkP5GufNOeH'
    },

    {
        title: 'Tachyon Deliverance',
        img: '/assets/images/projects/TachyonStill_2.5.2.jpg',
        //link: 'https://films.buzzstudios.org/tachyondeliverance',
        link: 'https://connorwright1122.github.io/tachyon-deliverance/',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2025',
            tools: 'Blender, DaVinci Resolve, Figma, Invoke AI, Bambu Studio, Hunyuan3D',
            role: 'Director, Writer, Editor, VFX, Production Design'
        },
        //social_url: 'https://youtu.be/RlQvampEqFw?si=CUWbOjkP5GufNOeH'
    },

    
    

    
    {
        title: 'LMC 3252 - Spatial Analysis',
        //img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'LMC 3252 - Studies in Film & Television',
            date: 'Spring 2023',
            tools: 'DaVinci Resolve'
        },
        social_url: 'https://youtu.be/IY7mXzEFMeA'
    },


    {
        title: 'The Legacy of Nick Fast',
        //img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'HS Film Capstone',
            date: 'Spring 2022',
            tools: 'DaVinci Resolve, Blender'
        },
        social_url: 'https://youtu.be/184llFZDiiI?si=xY8Hb8D8DM2_NYbT'
    },

];

export const btsData = [
    {
        title: 'Fire and Sound - Teardrop VFX Test',
        //img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2026',
            //tools: 'DaVinci Resolve'
        },
        social_url: 'https://youtu.be/OawS1lpmIdE'
    },
    
    {
        title: 'Tachyon Deliverance - VFX Breakdown',
        //img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Fall 2025',
            //tools: 'DaVinci Resolve'
        },
        social_url: 'https://youtu.be/3PaImfxnCLo'
    },

    {
        title: 'Tachyon Deliverance - BTS Slideshow',
        //img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Fall 2025',
            //tools: 'DaVinci Resolve'
        },
        social_url: 'https://youtu.be/xtuSPE1R4mg'
    },
    
    {
        title: 'Tachyon Deliverance - SCUFF Q&A',
        //img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'South Carolina Underground Film Festival',
            date: 'Fall 2025',
            //tools: 'DaVinci Resolve'
        },
        social_url: 'https://youtu.be/-aspCJReV70'
    },
    
    {
        title: 'Tachyon Deliverance - AmAuteur Film Festival Q&A',
        //img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'AmAuteur Film Festival',
            date: 'Fall 2025',
            //tools: 'DaVinci Resolve'
        },
        social_url: 'https://youtu.be/SLMdLDK1_P0'
    },
    
    {
        title: 'Tachyon Deliverance - VFX Test',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2025',
            tools: 'Blender, DaVinci Resolve'
        },
        social_url: 'https://youtu.be/gkZM0LXg4BQ'
    },

    {
        title: 'You Are Here - VFX Tests',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'Short Film VFX Test',
            date: 'Winter 2024',
            tools: 'Blender'
        },
        social_url: 'https://www.instagram.com/p/DSYWNvNCRaF/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    },

    {
        title: 'You Are Here - Intro / VFX Test',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'Short Film VFX Test',
            date: 'Winter 2024',
            tools: 'Blender, DaVinci Resolve'
        },
        social_url: 'https://youtu.be/SBEmswC7kdA'
    },

    {
        title: 'Blender Motion Capture Claymation Test',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'Personal Project',
            date: 'Winter 2024',
            tools: 'Blender, Rokoko Studio, DaVinci Resolve'
        },
        social_url: 'https://youtu.be/sZq4re2WmEk'
    },
    {
        title: 'Mitch the Terrifying Eldritch Abomination',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'AI VFX + Real Footage Test',
            date: 'Summer 2024',
            tools: 'InvokeAI, ComfyUI, Stable Diffusion, DaVinci Resolve'
        },
        social_url: 'https://youtu.be/Uk1OkkyN020'
    },

    {
        title: 'STEM Capstone / RUINAE Devlog',
        //img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'HS STEM Capstone',
            date: 'Spring 2022',
            tools: 'DaVinci Resolve, Unity, Blender'
        },
        social_url: 'https://youtu.be/9sXVUT4wrY0'
    },
    
] 

export const threedData = [
    {
        title: 'The Big Top Banana Hat Fruit Fly Flea Circus',
        //img: '/assets/images/extras/AtopAMountainOfGlass.png',
        //link: '#',
        details: {
            origin: 'Autodesk @ GT Make-A-Thon',
            date: 'Spring 2026',
            tools: 'Maya, Blender, Photoshop'
        },
        social_url: 'https://www.instagram.com/p/DXF9mPzDJIp/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA=='
    },
    
    {
        title: 'Atop a Mountain of Glass',
        img: '/assets/images/extras/AtopAMountainOfGlass.png',
        //link: '#',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Fall 2024',
            tools: 'Blender, Photoshop'
        },
        //social_url: 'https://www.instagram.com/p/DQX5xZyic1Z/?hl=en&img_index=1'
    },
    
    {
        title: 'you are here',
        //img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            origin: 'Erato Literary & Arts Magazine (54th Edition)',
            date: 'Fall 2023',
            tools: 'Blender, Figma, Photoshop'
        },
        social_url: 'https://www.instagram.com/p/DQX5xZyic1Z/?hl=en&img_index=1'
    },
    
    {
        title: 'Self Portrait',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Fall 2022',
            tools: 'Blender'
        },
        social_url: 'https://www.instagram.com/p/Cqik_UDLbq2/?hl=en&img_index=1'
    },
    {
        title: 'Monday is a Heavy Burden',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2023',
            tools: 'Blender'
        },
        social_url: 'https://www.instagram.com/p/CskQ8ENufMr/?hl=en&img_index=1'
    },

    {
        title: 'LMC 2700 - 2D Art Recreation in 3D',
        img: '/assets/images/extras/2700-aframe.png',
        link: 'https://connorwright1122.github.io/2700-Aframe/',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2023',
            tools: 'A-Frame, Three.js, HTML'
        },
        //social_url: 'https://connorwright1122.github.io/2700-Aframe/'
    },

    {
        title: 'Value Select Logo',
        img: '/assets/images/extras/2700-aframe.png',
        //link: 'https://connorwright1122.github.io/2700-Aframe/',
        details: {
            origin: '3D Logo for comedy-musician Value Select, featured in videos with +1M views',
            date: 'Spring 2022',
            tools: 'Blender'
        },
        social_url: 'https://youtu.be/4dsOJff34RM'
    },
];

export const designData = [
    {
        title: 'Cleanup Crew - Logo',
        img: '/assets/images/extras/cleanup-crew.JPG',
        //link: 'https://core-lab.org/coremusic/',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Fall 2025',
            tools: 'Photoshop'
        },
        //social_url: 'https://youtu.be/4MlnR7H0rV8'
    },
    
    {
        title: 'Buzz Studios - 2024-2025 Shirt',
        img: '/assets/images/extras/shirts/BS_Shirt_Back_1.png',
        //link: 'https://core-lab.org/coremusic/',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2025',
            tools: 'Photoshop, Inkscape'
        },
        //social_url: 'https://youtu.be/4MlnR7H0rV8'
    },

    {
        title: 'Cortical Resilience Lab - Visual Artist',
        img: '/assets/images/extras/corelab-visualartist.png',
        link: 'https://core-lab.org/coremusic/',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2025',
            tools: 'Acrylic'
        },
        //social_url: 'https://youtu.be/4MlnR7H0rV8'
    },
    
    {
        title: 'Son Lux - Breathe In (AI Visualizer)',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Summer 2023',
            tools: 'Stable Diffusion, Deforum, DaVinci Resolve'
        },
        social_url: 'https://youtu.be/4MlnR7H0rV8'
    },

    {
        title: 'LMC 2720 Final Project',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2023',
            tools: 'Figma, Photoshop, Blender'
        },
        social_url: 'https://www.instagram.com/p/CvyQNSsMgBr/?hl=en&img_index=1'
    },
    
    {
        title: 'LMC 2720 Assignments',
        img: '/assets/images/experience/hirez-logo.jpeg',
        //link: '#',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2023',
            tools: 'Figma, Photoshop'
        },
        social_url: 'https://www.instagram.com/p/CvyNwBzJ1-8/?hl=en&img_index=1'
    },

    {
        title: 'Ivan Allen College Student Advisory Board - 2023-2024 Shirt',
        img: '/assets/images/extras/shirts/IAC-SAB-Shirt-Multi.png',
        //link: 'https://core-lab.org/coremusic/',
        details: {
            //origin: 'Buzz Studios Filmmaking Club',
            date: 'Spring 2023',
            tools: 'Figma, Inkscape'
        },
        //social_url: 'https://youtu.be/4MlnR7H0rV8'
    },
];